import loader from './lib/Loader';
import '@lottiefiles/lottie-player';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('menu', '.header');
loader('navbar', '.header');
loader('filters', '#filters');
loader('next-section', '.next-section');
loader('brandslider', '.brandslider');
loader('videopopup', '.media-blocks__videoinner');
loader('video', '.media-blocks__video');
loader('center-arrow', '.blogcard');
loader('play-on-scroll', '.play-on-scroll');
loader('blog-card', '.blogcard');
